export type NotificationHref =
  | { kind: 'none' }
  | { kind: 'external'; url: string }
  | { kind: 'internal'; path: string }

/**
 * Desk routes live at the app root (`/pro/exit/...`), not under `/t/:tenantId`.
 * Relative action urls get a leading slash. Absolute http(s) links stay external.
 * Tenant-scoped paths must already include `/t/{tenantId}/...`.
 */
export function resolveNotificationHref(actionUrl: string | null | undefined): NotificationHref {
  const raw = actionUrl?.trim() ?? ''
  if (raw.length === 0) return { kind: 'none' }
  if (/^https?:\/\//i.test(raw)) return { kind: 'external', url: raw }
  const path = raw.startsWith('/') ? raw : `/${raw}`
  return { kind: 'internal', path }
}
